import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.gifts';
export const Component = loadable(() => import('./containers/GiftsContainer'));
export { default as propsFormatter } from './propsFormatter';
